import styled from 'styled-components';

export const SearchArea = styled.div`
  width: 100%;
  max-width: calc(40rem - 3px);
  background-color: white;
`;

export const Container = styled.div`
  height: calc(100vh - 7rem);
  overflow: auto;
`;
